import React, { useState, useEffect } from 'react'

import { Table, TableHead, TableBody, TableRow, TableCell, TextField, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Grid, Typography, Divider } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

import { commonStyle } from '../../../../../styles'

let template = {
  PLACEMENT_ID: {
    DESKTOP: {
      DOM: {
        HOMEPAGE_BNR_ATF: 1728514,
        HOMEPAGE_RECT_ATF: 1728507,
        HOMEPAGE_BNR_BTF: 1728511,
        HOMEPAGE_RECT_BTF: 1728500,
        ROS_BNR_ATF : 1728506,
        ROS_BNR_BTF : 1728503,
        ROS_RECT_ATF : 1728510,
        ROS_RECT_BTF : 1728515, 
        ROS_MULTI_ATF: 1728502
      },
      INTL : {
        HOMEPAGE_BNR_ATF: 0,
        HOMEPAGE_RECT_ATF: 0,
        HOMEPAGE_BNR_BTF: 0,
        HOMEPAGE_RECT_BTF: 0,
        ROS_BNR_ATF : 0,
        ROS_BNR_BTF : 0,
        ROS_RECT_ATF : 0,
        ROS_RECT_BTF : 0,
        ROS_MULTI_ATF : 0
      }
    },
    MOBILE : {
      DOM: {
        HOMEPAGE_BNR_ATF: 1728514,
        HOMEPAGE_RECT_ATF: 1728507,
        HOMEPAGE_BNR_BTF: 1728511,
        HOMEPAGE_RECT_BTF: 1728500,
        ROS_BNR_ATF : 1728506,
        ROS_BNR_BTF : 1728503,
        ROS_RECT_ATF : 1728510,
        ROS_RECT_BTF : 1728515,
        ROS_MULTI_ATF : 1728502
      },
      INTL : {
        HOMEPAGE_BNR_ATF: 0,
        HOMEPAGE_RECT_ATF: 0,
        HOMEPAGE_BNR_BTF: 0,
        HOMEPAGE_RECT_BTF: 0,
        ROS_BNR_ATF : 0,
        ROS_BNR_BTF : 0,
        ROS_RECT_ATF : 0,
        ROS_RECT_BTF : 0,
        ROS_MULTI_ATF : 0                   
      }
    }
  }
}

const isObject = (item) => {
  return (item && typeof item === 'object' && !Array.isArray(item))
}

const mergeDeep = (target, ...sources) => {
  if (!sources.length) {
    // console.log('No more sources. Returning target: ', target)
    return target
  }
  const source = sources.shift()
  // console.log('Merging in source: ', source)
  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) {
          Object.assign(target, {
            [key]: {}
          })
        }
        // console.log('Merging key: ', key)
        mergeDeep(target[key], source[key])
      } else {
        // console.log('Setting key: ', key)
        Object.assign(target, {
          [key]: source[key]
        })
      }
    }
  }

  return mergeDeep(target, ...sources)
}

export const Nativo = ({ expandAllVendors, options, allOptions, setOptions, setAllOptions, errors, setErrors, validation }) => {
  const commonClasses = commonStyle()
  const { PREBID } = options
  const { VENDOR } = PREBID
  let NATIVO = mergeDeep(template, VENDOR.NATIVO)

  let {
    PLACEMENT_ID
  } = NATIVO
  VENDOR.NATIVO = NATIVO  

  const { STRING } = validation
  const { LENGTH } = STRING
  const [expanded, setExpanded] = useState(expandAllVendors)

  useEffect(() => {
    setExpanded(expandAllVendors)
  }, [expandAllVendors])

  
  useEffect(() => {
    NATIVO = mergeDeep(template, VENDOR.NATIVO)   
    PLACEMENT_ID = NATIVO.PLACEMENT_ID
    VENDOR.NATIVO = NATIVO
  }, [VENDOR])

  const placementIdUi = () => {
    return (
      <Table size='small' aria-label='NATIVO-account-id-table'>
        <TableHead>
          <TableRow>
            <TableCell style={{ width: '180px' }}><Typography variant='h6' style={{ fontWeight: 'bolder' }}>Zone Mappings</Typography></TableCell>
            <TableCell style={{ textAlign: 'center' }}>DOM PLACEMENT_ID</TableCell>
            <TableCell style={{ textAlign: 'center' }}>INTL PLACEMENT_ID</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Desktop</TableCell>
            <TableCell>
              <Grid container spacing = {2}>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='HP BNR atf'
                    value={PLACEMENT_ID.DESKTOP.DOM.HOMEPAGE_BNR_ATF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_A}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_A && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.DESKTOP.DOM.HOMEPAGE_BNR_ATF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_A: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='HP BNR btf'
                    value={PLACEMENT_ID.DESKTOP.DOM.HOMEPAGE_BNR_BTF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_B}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_B && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.DESKTOP.DOM.HOMEPAGE_BNR_BTF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_B: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='HP RECT atf'
                    value={PLACEMENT_ID.DESKTOP.DOM.HOMEPAGE_RECT_ATF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_A}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_A && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.DESKTOP.DOM.HOMEPAGE_RECT_ATF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_A: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='HP RECT btf'
                    value={PLACEMENT_ID.DESKTOP.DOM.HOMEPAGE_RECT_BTF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_B}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_B && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.DESKTOP.DOM.HOMEPAGE_RECT_BTF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_B: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='ROS BNR atf'
                    value={PLACEMENT_ID.DESKTOP.DOM.ROS_BNR_ATF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_A}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_A && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.DESKTOP.DOM.ROS_BNR_ATF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_A: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='ROS BNR btf'
                    value={PLACEMENT_ID.DESKTOP.DOM.ROS_BNR_BTF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_A}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_A && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.DESKTOP.DOM.ROS_BNR_BTF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_A: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='ROS RECT atf'
                    value={PLACEMENT_ID.DESKTOP.DOM.ROS_RECT_ATF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_B}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_B && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.DESKTOP.DOM.ROS_RECT_ATF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_B: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='ROS RECT btf'
                    value={PLACEMENT_ID.DESKTOP.DOM.ROS_RECT_BTF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_B}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_B && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.DESKTOP.DOM.ROS_RECT_BTF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_B: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='ROS MULTI atf'
                    value={PLACEMENT_ID.DESKTOP.DOM.ROS_MULTI_ATF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_B}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_B && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.DESKTOP.DOM.ROS_MULTI_ATF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_B: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}></Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container spacing = {2}>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='HP BNR atf'
                    value={PLACEMENT_ID.DESKTOP.INTL.HOMEPAGE_BNR_ATF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_A}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_A && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.DESKTOP.INTL.HOMEPAGE_BNR_ATF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_A: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='HP BNR btf'
                    value={PLACEMENT_ID.DESKTOP.INTL.HOMEPAGE_BNR_BTF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_B}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_B && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.DESKTOP.INTL.HOMEPAGE_BNR_BTF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_B: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='HP RECT atf'
                    value={PLACEMENT_ID.DESKTOP.INTL.HOMEPAGE_RECT_ATF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_A}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_A && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.DESKTOP.INTL.HOMEPAGE_RECT_ATF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_A: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='HP RECT btf'
                    value={PLACEMENT_ID.DESKTOP.INTL.HOMEPAGE_RECT_BTF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_B}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_B && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.DESKTOP.INTL.HOMEPAGE_RECT_BTF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_B: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='ROS BNR atf'
                    value={PLACEMENT_ID.DESKTOP.INTL.ROS_BNR_ATF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_A}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_A && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.DESKTOP.INTL.ROS_BNR_ATF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_A: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='ROS BNR btf'
                    value={PLACEMENT_ID.DESKTOP.INTL.ROS_BNR_BTF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_A}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_A && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.DESKTOP.INTL.ROS_BNR_BTF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_A: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='ROS RECT atf'
                    value={PLACEMENT_ID.DESKTOP.INTL.ROS_RECT_ATF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_B}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_B && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.DESKTOP.INTL.ROS_RECT_ATF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_B: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='ROS RECT btf'
                    value={PLACEMENT_ID.DESKTOP.INTL.ROS_RECT_BTF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_B}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_B && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.DESKTOP.INTL.ROS_RECT_BTF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_B: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                 <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='ROS MULTI atf'
                    value={PLACEMENT_ID.DESKTOP.INTL.ROS_MULTI_ATF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_B}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_B && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.DESKTOP.INTL.ROS_MULTI_ATF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_B: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}></Grid>
              </Grid>     
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Mobile</TableCell>
            <TableCell>
              <Grid container spacing = {2}>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='HP BNR atf'
                    value={PLACEMENT_ID.MOBILE.DOM.HOMEPAGE_BNR_ATF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_A}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_A && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.MOBILE.DOM.HOMEPAGE_BNR_ATF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_A: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='HP BNR btf'
                    value={PLACEMENT_ID.MOBILE.DOM.HOMEPAGE_BNR_BTF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_B}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_B && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.MOBILE.DOM.HOMEPAGE_BNR_BTF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_B: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='HP RECT atf'
                    value={PLACEMENT_ID.MOBILE.DOM.HOMEPAGE_RECT_ATF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_A}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_A && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.MOBILE.DOM.HOMEPAGE_RECT_ATF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_A: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='HP RECT btf'
                    value={PLACEMENT_ID.MOBILE.DOM.HOMEPAGE_RECT_BTF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_B}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_B && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.MOBILE.DOM.HOMEPAGE_RECT_BTF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_B: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='ROS BNR atf'
                    value={PLACEMENT_ID.MOBILE.DOM.ROS_BNR_ATF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_A}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_A && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.MOBILE.DOM.ROS_BNR_ATF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_A: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='ROS BNR btf'
                    value={PLACEMENT_ID.MOBILE.DOM.ROS_BNR_BTF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_A}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_A && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.MOBILE.DOM.ROS_BNR_BTF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_A: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='ROS RECT atf'
                    value={PLACEMENT_ID.MOBILE.DOM.ROS_RECT_ATF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_B}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_B && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.MOBILE.DOM.ROS_RECT_ATF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_B: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='ROS RECT btf'
                    value={PLACEMENT_ID.MOBILE.DOM.ROS_RECT_BTF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_B}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_B && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.MOBILE.DOM.ROS_RECT_BTF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_B: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='ROS MULTI atf'
                    value={PLACEMENT_ID.MOBILE.DOM.ROS_MULTI_ATF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_B}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_B && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.MOBILE.DOM.ROS_MULTI_ATF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_B: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}></Grid>
              </Grid>
            </TableCell>
            <TableCell>
              <Grid container spacing = {2}>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='HP BNR atf'
                    value={PLACEMENT_ID.MOBILE.INTL.HOMEPAGE_BNR_ATF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_A}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_A && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.MOBILE.INTL.HOMEPAGE_BNR_ATF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_A: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='HP BNR btf'
                    value={PLACEMENT_ID.MOBILE.INTL.HOMEPAGE_BNR_BTF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_B}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_B && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.MOBILE.INTL.HOMEPAGE_BNR_BTF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_B: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='HP RECT atf'
                    value={PLACEMENT_ID.MOBILE.INTL.HOMEPAGE_RECT_ATF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_A}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_A && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.MOBILE.INTL.HOMEPAGE_RECT_ATF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_A: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='HP RECT btf'
                    value={PLACEMENT_ID.MOBILE.INTL.HOMEPAGE_RECT_BTF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_B}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_B && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.MOBILE.INTL.HOMEPAGE_RECT_BTF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_B: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='ROS BNR atf'
                    value={PLACEMENT_ID.MOBILE.INTL.ROS_BNR_ATF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_A}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_A && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.MOBILE.INTL.ROS_BNR_ATF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_A: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='ROS BNR btf'
                    value={PLACEMENT_ID.MOBILE.INTL.ROS_BNR_BTF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_A}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_A && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.MOBILE.INTL.ROS_BNR_BTF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_A: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='ROS RECT atf'
                    value={PLACEMENT_ID.MOBILE.INTL.ROS_RECT_ATF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_B}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_B && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.MOBILE.INTL.ROS_RECT_ATF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_B: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='ROS RECT btf'
                    value={PLACEMENT_ID.MOBILE.INTL.ROS_RECT_BTF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_B}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_B && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.MOBILE.INTL.ROS_RECT_BTF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_B: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}>
                  <TextField
                    margin='none'
                    label='ROS MULTI atf'
                    value={PLACEMENT_ID.MOBILE.INTL.ROS_MULTI_ATF}
                    error={errors.PREBID_NATIVO_ZM_DD_HP_B}
                    helperText={errors.PREBID_NATIVO_ZM_DD_HP_B && LENGTH.message}
                    onChange={(event) => {
                      const value = event.target.value
                      PREBID.VENDOR.NATIVO.PLACEMENT_ID.MOBILE.INTL.ROS_MULTI_ATF = value
                      setErrors({ ...errors, PREBID_NATIVO_ZM_DD_HP_B: value.length < LENGTH.min || value.length > LENGTH.max })
                      setOptions({ ...options, PREBID })
                      setAllOptions({ ...allOptions, PREBID })
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6}></Grid>
              </Grid>     
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    )
  }

  return (
    <ExpansionPanel expanded={expanded}>
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls='NATIVO-panel-content'
        id='NATIVO-panel-header'
        onClick={() => setExpanded(!expanded)}
      >
        <Typography variant='h5'>Nativo</Typography>
      </ExpansionPanelSummary>
      <Divider />
      <ExpansionPanelDetails>
        <Grid container>
          <Grid className={commonClasses.mb_3} item xs={12}>{placementIdUi()}</Grid>
        </Grid>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
}
